import { createContext, useSyncExternalStore } from "react";

interface ViewportContextInterface {
  isMobile: boolean;
}

export const ViewportContext = createContext<ViewportContextInterface>({
  isMobile: false,
});

const MOBILE_QUERY = "(max-width: 768px)";

const subscribe = (callback: () => void) => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return () => {};
  }

  const mediaQueryList = window.matchMedia(MOBILE_QUERY);
  mediaQueryList.addEventListener("change", callback);

  return () => mediaQueryList.removeEventListener("change", callback);
};

const getSnapshot = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(MOBILE_QUERY).matches;

const getServerSnapshot = () => false;

export const ViewportProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isMobile = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );

  return (
    <ViewportContext.Provider value={{ isMobile }}>
      {children}
    </ViewportContext.Provider>
  );
};
